import React, { useState } from 'react';
import Styles from './Renegociacao25Banner.css';
import WhiteButton from '@/components/atoms/WhiteButton';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
function Renegociacao25Banner({ currentTab }) {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);

  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section id="renegociacao25-banner" className="stacked-banner">
        {currentTab === 0 && (
          <div className="bg-image-wrapper">
            {typeof window === 'undefined' ? (
              <></>
            ) : (
              <>
                {width <= 320 && (
                  <picture>
                    <source type="image/webp" srcSet="assets/renegociacao25/hero/hero-320.webp" />
                    <source type="image/png" srcSet="assets/renegociacao25/hero/hero-320.png" />
                    <img
                      src="assets/renegociacao25/hero/hero-320.png"
                      alt="Homem branco com computador pesquisando sobre renegociar o seu contrato atrasado ou reorganizar seu contrato em dia na Santander Financiamentos."
                    />
                  </picture>
                )}
                {width > 320 && width <= 450 && (
                  <picture>
                    <source type="image/webp" srcSet="assets/renegociacao25/hero/hero-450.webp" />
                    <source type="image/png" srcSet="assets/renegociacao25/hero/hero-450.png" />
                    <img
                      src="assets/renegociacao25/hero/hero-450.png"
                      alt="Homem branco com computador pesquisando sobre renegociar o seu contrato atrasado ou reorganizar seu contrato em dia na Santander Financiamentos."
                    />
                  </picture>
                )}
                {width > 450 && width <= 800 && (
                  <picture>
                    <source type="image/webp" srcSet="assets/renegociacao25/hero/hero-800.webp" />
                    <source type="image/png" srcSet="assets/renegociacao25/hero/hero-800.png" />
                    <img
                      src="assets/renegociacao25/hero/hero-800.png"
                      alt="Homem branco com computador pesquisando sobre renegociar o seu contrato atrasado ou reorganizar seu contrato em dia na Santander Financiamentos."
                    />
                  </picture>
                )}
                {width > 800 && width <= 1280 && (
                  <picture>
                    <source type="image/webp" srcSet="assets/renegociacao25/hero/hero-1280.webp" />
                    <source type="image/png" srcSet="assets/renegociacao25/hero/hero-1280.png" />
                    <img
                      src="assets/renegociacao25/hero/hero-1280.png"
                      alt="Homem branco com computador pesquisando sobre renegociar o seu contrato atrasado ou reorganizar seu contrato em dia na Santander Financiamentos."
                    />
                  </picture>
                )}
                {width > 1280 && width <= 1360 && (
                  <picture>
                    <source type="image/webp" srcSet="assets/renegociacao25/hero/hero-1360.webp" />
                    <source type="image/png" srcSet="assets/renegociacao25/hero/hero-1360.png" />
                    <img
                      src="assets/renegociacao25/hero/hero-1360.png"
                      alt="Homem branco com computador pesquisando sobre renegociar o seu contrato atrasado ou reorganizar seu contrato em dia na Santander Financiamentos."
                    />
                  </picture>
                )}
                {width > 1360 && (
                  <picture>
                    <source type="image/webp" srcSet="assets/renegociacao25/hero/hero-1440.webp" />
                    <source type="image/png" srcSet="assets/renegociacao25/hero/hero-1440.png" />
                    <img
                      src="assets/renegociacao25/hero/hero-1440.png"
                      alt="Homem branco com computador pesquisando sobre renegociar o seu contrato atrasado ou reorganizar seu contrato em dia na Santander Financiamentos."
                    />
                  </picture>
                )}
              </>
            )}

            {/* <picture>
            <source type="image/webp" srcSet="assets/renegociacao25/hero/hero.webp" />
            <source type="image/png" srcSet="assets/renegociacao25/hero/hero.png" />
            <img src="assets/renegociacao25/hero/hero.png" alt="" />
          </picture> */}
          </div>
        )}
        {currentTab === 1 && (
          <div className="bg-image-wrapper">
            {typeof window === 'undefined' ? (
              <></>
            ) : (
              <>
                {width <= 320 && (
                  <picture>
                    <source
                      type="image/webp"
                      srcSet="assets/renegociacao25-emp/hero/hero-320.webp"
                    />
                    <source type="image/png" srcSet="assets/renegociacao25-emp/hero/hero-320.png" />
                    <img
                      src="assets/renegociacao25-emp/hero/hero-320.png"
                      alt="Pessoa com camisa vermelha, sentada à frente de um notebook em um ambiente claro, realizando uma renegociação do seu contrato de empréstimo com o Santander."
                    />
                  </picture>
                )}
                {width > 320 && width <= 450 && (
                  <picture>
                    <source
                      type="image/webp"
                      srcSet="assets/renegociacao25-emp/hero/hero-450.webp"
                    />
                    <source type="image/png" srcSet="assets/renegociacao25-emp/hero/hero-450.png" />
                    <img
                      src="assets/renegociacao25-emp/hero/hero-450.png"
                      alt="Pessoa com camisa vermelha, sentada à frente de um notebook em um ambiente claro, realizando uma renegociação do seu contrato de empréstimo com o Santander."
                    />
                  </picture>
                )}
                {width > 450 && width <= 800 && (
                  <picture>
                    <source
                      type="image/webp"
                      srcSet="assets/renegociacao25-emp/hero/hero-800.webp"
                    />
                    <source type="image/png" srcSet="assets/renegociacao25-emp/hero/hero-800.png" />
                    <img
                      src="assets/renegociacao25-emp/hero/hero-800.png"
                      alt="Pessoa com camisa vermelha, sentada à frente de um notebook em um ambiente claro, realizando uma renegociação do seu contrato de empréstimo com o Santander."
                    />
                  </picture>
                )}
                {width > 800 && width <= 992 && (
                  <picture>
                    <source
                      type="image/webp"
                      srcSet="assets/renegociacao25-emp/hero/hero-992.webp"
                    />
                    <source type="image/png" srcSet="assets/renegociacao25-emp/hero/hero-992.png" />
                    <img
                      src="assets/renegociacao25-emp/hero/hero-992.png"
                      alt="Pessoa com camisa vermelha, sentada à frente de um notebook em um ambiente claro, realizando uma renegociação do seu contrato de empréstimo com o Santander."
                    />
                  </picture>
                )}
                {width > 992 && width <= 1280 && (
                  <picture>
                    <source
                      type="image/webp"
                      srcSet="assets/renegociacao25-emp/hero/hero-1280.webp"
                    />
                    <source
                      type="image/png"
                      srcSet="assets/renegociacao25-emp/hero/hero-1280.png"
                    />
                    <img
                      src="assets/renegociacao25-emp/hero/hero-1280.png"
                      alt="Pessoa com camisa vermelha, sentada à frente de um notebook em um ambiente claro, realizando uma renegociação do seu contrato de empréstimo com o Santander."
                    />
                  </picture>
                )}
                {width > 1280 && width <= 1360 && (
                  <picture>
                    <source
                      type="image/webp"
                      srcSet="assets/renegociacao25-emp/hero/hero-1360.webp"
                    />
                    <source
                      type="image/png"
                      srcSet="assets/renegociacao25-emp/hero/hero-1360.png"
                    />
                    <img
                      src="assets/renegociacao25-emp/hero/hero-1360.png"
                      alt="Pessoa com camisa vermelha, sentada à frente de um notebook em um ambiente claro, realizando uma renegociação do seu contrato de empréstimo com o Santander."
                    />
                  </picture>
                )}
                {width > 1360 && width <= 1440 && (
                  <picture>
                    <source
                      type="image/webp"
                      srcSet="assets/renegociacao25-emp/hero/hero-1440.webp"
                    />
                    <source
                      type="image/png"
                      srcSet="assets/renegociacao25-emp/hero/hero-1440.png"
                    />
                    <img
                      src="assets/renegociacao25-emp/hero/hero-1440.png"
                      alt="Pessoa com camisa vermelha, sentada à frente de um notebook em um ambiente claro, realizando uma renegociação do seu contrato de empréstimo com o Santander."
                    />
                  </picture>
                )}
                {width > 1440 && width <= 1920 && (
                  <picture>
                    <source
                      type="image/webp"
                      srcSet="assets/renegociacao25-emp/hero/hero-1920.webp"
                    />
                    <source
                      type="image/png"
                      srcSet="assets/renegociacao25-emp/hero/hero-1920.png"
                    />
                    <img
                      src="assets/renegociacao25-emp/hero/hero-1920.png"
                      alt="Pessoa com camisa vermelha, sentada à frente de um notebook em um ambiente claro, realizando uma renegociação do seu contrato de empréstimo com o Santander."
                    />
                  </picture>
                )}
                {width > 1920 && (
                  <picture>
                    <source
                      type="image/webp"
                      srcSet="assets/renegociacao25-emp/hero/hero-2650.webp"
                    />
                    <source
                      type="image/png"
                      srcSet="assets/renegociacao25-emp/hero/hero-2650.png"
                    />
                    <img
                      src="assets/renegociacao25-emp/hero/hero-2650.png"
                      alt="Pessoa com camisa vermelha, sentada à frente de um notebook em um ambiente claro, realizando uma renegociação do seu contrato de empréstimo com o Santander."
                    />
                  </picture>
                )}
              </>
            )}

            {/* <picture>
            <source type="image/webp" srcSet="assets/renegociacao25/hero/hero.webp" />
            <source type="image/png" srcSet="assets/renegociacao25/hero/hero.png" />
            <img src="assets/renegociacao25/hero/hero.png" alt="" />
          </picture> */}
          </div>
        )}
        {/* <div className="fade-banner" /> */}
        {/* <div className="fade-banner-gradiente" /> */}
        <div className="santander-symbol" />

        <div className="text-box-position">
          <ContainerHome24>
            <div className="text-box">
              <h1 className="main-text">Renegociação Santander Financiamentos</h1>
              <p className="alt-text">
                Aqui você pode renegociar ou reorganizar o seu contrato para aliviar o seu bolso.
              </p>
              <WhiteButton
                href={
                  currentTab === 0
                    ? 'https://santanderfinanciamentos.com.br/portalcliente/login'
                    : 'https://quiteja.com.br/parceiros/sim'
                }
                rel="noopener"
                target="_blank"
                className="btn-reneg"
              >
                Renegociar
              </WhiteButton>
            </div>
          </ContainerHome24>
        </div>
      </section>

      <style jsx>{Styles}</style>
    </>
  );
}

export default Renegociacao25Banner;
